import { Button, Badge, Box } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { Filter } from 'api-paths-cas';

export interface IProps {
  filter: Filter;
  openFilter: () => void;
  count: number;
}

export const FilterItem = ({ filter, openFilter, count }: IProps) => {
  const isActive = count > 0;

  return (
    <Button
      variant="ghost"
      colorScheme={'gray'}
      onClick={openFilter}
      data-selector={`filter-item-${filter.key}`}
      rightIcon={<FontAwesomeIcon className="utility-icon" icon={faAngleRight} />}
      whiteSpace="normal"
      textAlign="left"
      height="initial"
      py="3"
      _hover={{
        bgColor: 'utility.100',
      }}
    >
      <Box flexGrow={1} fontWeight={isActive ? 'medium' : 'regular'}>
        {filter.name}
      </Box>

      {isActive && (
        <Badge variant="vivid-pill" colorScheme="blue" ml={2}>
          {count}
        </Badge>
      )}
    </Button>
  );
};
